import * as fmt from 'shared/payments/fmt';
import * as pmtmath from 'shared/payments/math';
import { useIntl } from 'shared/intl/use-intl';
import { PriceRow, CouponRow } from 'server/types';

type Props = {
  price: PriceRow;
  coupon?: CouponRow;
};

export function PriceDisplay({ price, coupon }: Props) {
  const intl = useIntl();
  const { initial, final } = pmtmath.batches({ price, coupon });

  return (
    <h3 class="inline-flex gap-1 text-4xl font-semibold mb-3">
      {fmt.price(price)}
      <span>
        {initial
          ? fmt.firstBatchSuffix({ item: initial, intl })
          : fmt.priceSuffix({ item: final, intl })}
      </span>
      {initial && (
        <span class="block">
          {intl('then')} {fmt.price(final)} {fmt.priceSuffix({ item: final, intl })}
        </span>
      )}
    </h3>
  );
}
